module.exports = __webpack_public_path__ + "static/img/home_new4.fb1ad409.jpg";